export function ensureError(err: unknown): Error {
  if (err instanceof Error) {
    return err;
  }
  let message;
  if (isObject(err)) {
    if (typeof err.message === "string") {
      message = err.message;
    } else if (typeof err.error === "string") {
      message = err.error;
    }
  } else if (typeof err === "string") {
    message = err;
  }
  if (message === undefined) {
    try {
      message = "" + err;
    } catch {
      // …
    }
  }
  return new Error(message);
}

function isObject(err: unknown): err is { [k in string]: unknown } {
  return typeof err === "object" && !!err;
}
